import { render } from "./ItinenerySection.vue?vue&type=template&id=0fec1645&scoped=true"
import script from "./ItinenerySection.vue?vue&type=script&lang=js"
export * from "./ItinenerySection.vue?vue&type=script&lang=js"

import "./ItinenerySection.vue?vue&type=style&index=0&id=0fec1645&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fec1645"]])

export default __exports__